import React from 'react';
import FileTableIcon from '../../../img/icons/FileTableIcon.svg';

function FileTableComponent({ data, onClick }) {
  return (
    <div style={data ? { cursor: 'pointer' } : {}} onClick={onClick} className="d-flex flex-row w-100">
      <img src={FileTableIcon} width={16} height={20} className="me-2" />
      <span
        style={data ? { color: '#305FFD' } : {}}
      >
        {data}
      </span>
    </div>
  );
}

export default FileTableComponent;
